import axiosInstance from "../lib/axiosInstance";

class orderItemModel {
  constructor() {
    this.base_url = "/order-items";
   
  }
  async list(query = []) {
    return (
      await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)
    ).data;
  }

}

export default new orderItemModel();
